module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/index/img_passage-d61abc4890044af5cb934b8e5005953d.png";